import { render, staticRenderFns } from "./ZoneWizardAddResources.vue?vue&type=template&id=b54b3c4c&"
import script from "./ZoneWizardAddResources.vue?vue&type=script&lang=js&"
export * from "./ZoneWizardAddResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports